import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import BASE_URL from "../../../baseUrl";
import ListingCard from "../../shared/ListingCard";

const Latestblog = () => {
  const [state, setState] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const customeSlider = useRef();
  const { t } = useTranslation();

  const SubmitlistingData = async () => {
    try {
      const response = await fetch(`${BASE_URL}/admin/bestDeals`);
      const data = await response.json();
      setState(data?.result || []);
    } catch (error) {
      console.error("Error fetching listing data:", error);
    }
  };

  useEffect(() => {
    SubmitlistingData();
  }, []);

  const next = () => {
    if (customeSlider.current) {
      customeSlider.current.slickNext();
    }
  };

  const previous = () => {
    if (customeSlider.current) {
      customeSlider.current.slickPrev();
    }
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSlidesToShow(1);
      } else if (width < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    initialSlide: 0,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: false,
        },
      },
    ],
  };

  return (
    <div className="section section-padding light-bg">
      <div className="container">
        <div className="section-title-wrap section-header">
          <h5 className="custom-primary">{t("latestNews")}</h5>
          <h2 className="title">{t("bestDealOfTheMonth")}</h2>
        </div>

        <Slider
          className="top-listings-slider"
          ref={customeSlider}
          {...settings}
        >
          {state.length === 0 ? (
            <p className="text-center my-4 text-xl font-medium">
              {t("No Deals Available")}
            </p>
          ) : (
            state.map((res, key) => (
              <ListingCard key={key} listing={res} t={t} />
            ))
          )}
        </Slider>
        <div className="acr-arrows-top-listing">
          <button
            className="slider-prev-top-listing fas fa-arrow-left slick-arrow-top-listing"
            onClick={previous}
            disabled={currentSlide === 0}
          />
          <button
            className="slider-next-top-listing fas fa-arrow-right slick-arrow-top-listing"
            onClick={next}
            disabled={currentSlide >= state.length - slidesToShow}
          />
        </div>
      </div>
    </div>
  );
};

export default Latestblog;
